'use client';

import React__default from 'react';
import { CardContainer, CardItem, CardImage, CardContent, CardButton, CardButtonMobile } from './CompanyCard.js';

var CompanyCard = function (props) {
    var isMobile = props.isMobile, imageProp = props.imageProp, contentProp = props.contentProp, buttonProp = props.buttonProp, headerProp = props.headerProp;
    return (React__default.createElement(CardContainer, { className: 'view_job_item imp-click myjobs_list' },
        headerProp,
        React__default.createElement(CardItem, { isMobile: isMobile },
            React__default.createElement(CardImage, null, imageProp),
            React__default.createElement(CardContent, { isMobile: isMobile, isHaveButton: !!buttonProp }, contentProp),
            !isMobile && buttonProp && React__default.createElement(CardButton, null, buttonProp)),
        isMobile && buttonProp && React__default.createElement(CardButtonMobile, null, buttonProp)));
};

export { CompanyCard as default };
//# sourceMappingURL=index.js.map
